import $ from 'jquery';
import Form from 'root/module/form';
import Util from 'root/module/util';
import Cache from 'root/cache';
import View from 'view/base';

export default View.extend({
    className: 'region-create-workspace',

    subdomain_availability: {},

    events: {
        'keydown input[name="subdomain"]'  : 'onBeforeChangeSubdomain',
        'input input[name="subdomain"]'    : 'onChangeSubdomain',
        'input input[name="display_name"]' : 'onDisplayNameChange',
        'click .logo-upload'               : 'onSelectLogo',
        'click .logo-remove'               : 'onRemoveLogo',
        'click .submit'                    : 'onSubmit'
    },

    dom_handlers: {
        onBeforeChangeSubdomain: function(e) {
            if (!e.key.match(/[a-zA-Z0-9-]/)) {
                e.preventDefault();
                return;
            }
        },

        onChangeSubdomain: function(e) {
            this.subdomain_changed = true;

            var subdomain = $(e.currentTarget).val().trim();

            var subdomain_sanitised = Util.sanitizeCustomSubdomain(subdomain);

            if (subdomain !== subdomain_sanitised) {
                $(e.currentTarget).val(subdomain_sanitised);
            }

          //  if (!subdomain_sanitised) {
          //      this.$el.find('.url-taken').hide();
          //      this.$el.find('.url-validation').html('');
          //      return;
          //  }

            clearTimeout(this.subdomain_timeout);
            this.subdomain_timeout = setTimeout(() => {
                this.checkSubdomain(subdomain_sanitised);
            }, 100);
        },

        onDisplayNameChange: function(e) {
            var workspace_name = Form.getData(this.$el, 'display_name');

            if (!this.logo_file.content) {
                this.renderLogo();
            }

            if (this.subdomain_changed) {
                this.checkFormChange();
            } else {
                var subdomain = Util.sanitizeCustomSubdomain(workspace_name);

                Form.setData(this.$el, {
                    subdomain: subdomain
                });

                this.checkSubdomain(subdomain);
            }
        },

        onSelectLogo: function(e) {
            e.preventDefault();

            Util.uploadImages(1, 10, (result) => {
                var image_result = result[0];
                var upload_error = this.$el.find('.logo-upload-error');

                if (image_result.error) {
                    upload_error.text(image_result.error);
                } else {
                    upload_error.text('');

                    this.logo_file = {
                        content : image_result.content,
                        type    : image_result.type,
                        name    : image_result.name
                    };
                }

                this.renderLogo();
            });
        },

        onRemoveLogo: function() {
            this.logo_file = {
                content : '',
                type    : '',
                name    : ''
            }

            this.renderLogo();
        },

        onSubmit: function(e) {
            var form_data = {...Form.getData(this.$el),
                logo_content : this.logo_file.content,
                logo_type    : this.logo_file.type,
                logo_name    : this.logo_file.name
            };

            this.$el.find('.submit').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'workspace/create',
                data: form_data,
                success: (response) => {
                    Cache.app.setDefaultWorkspace(response.workspace_id, () => {
                        window.location = '//' + form_data.subdomain + Cache.app.configs.workspace_host;
                    });
                }
            });
        }
    },

    initialize: function() {
        this.logo_file = {
            content : '',
            type    : '',
            name    : ''
        };
    },

    checkSubdomain: function(subdomain) {
        if (!subdomain) {
            this.$el.find('.url-taken').hide();
            this.$el.find('.url-validation').html('');
            return;
        }

        // cached result
        if (typeof this.subdomain_availability[subdomain] !== 'undefined') {
            this.renderSubdomainValidation(this.subdomain_availability[subdomain]);
            return;
        }

        this.$el.find('.url-validation').html('<i class="far fa-sync-alt fa-spin text-info"></i>');

        Cache.app.request({
            action: 'workspace/checkSubdomain',
            data: {
                subdomain: subdomain
            },
            error: () => {
                this.subdomain_availability[subdomain] = false;
                this.renderSubdomainValidation(false);
            },
            success: () => {
                this.subdomain_availability[subdomain] = true;
                this.renderSubdomainValidation(true);
            }
        });
    },

    checkFormChange: function() {
        var form_data = Form.getData(this.$el);

        if (form_data.display_name && form_data.subdomain && !this.invalid_subdomain) {
            this.$el.find('.submit').prop('disabled', false);
        } else {
            this.$el.find('.submit').prop('disabled', true);
        }
    },

    renderSubdomainValidation(success) {
        if (success) {
            this.$el.find('.url-validation').html('<i class="far fa-check text-success"></i>').show();
            this.$el.find('.url-taken').hide();

            this.invalid_subdomain = false;

            this.checkFormChange();
        } else {
            this.$el.find('.url-validation').html('<i class="far fa-times text-danger"></i>').show();
            this.$el.find('.url-taken').show();

            this.invalid_subdomain = true;

            this.checkFormChange();
        }
    },

    renderLogo: function() {
        var workspace_name = Form.getData(this.$el, 'display_name');

        var content = '';

        if (this.logo_file.content && this.logo_file.content !== 'delete') {
            content += '<img src="' + this.logo_file.content + '">';
            content += '<button type="button" class="logo-remove"><i class="fa-solid fa-times"></i></button>';
        } else if (workspace_name) {
            content += '<span>' + Util.htmlEntities(workspace_name.slice(0, 2)) + '</span>';
        } else {
            content += '<span>WS</span>';
        }

        content += '<a href="#" class="logo-upload">Upload Logo</a>';

        this.$el.find('.workspace-logo').html(content);
    },

    render: function() {
        var content =
        '<div class="form-fluid">' +
            '<div class="row">' +
                '<div class="field-label">Workspace Name</div>' +
                '<input type="text" name="display_name" class="solid medium" maxlength="100" placeholder="mycompany">' +
            '</div>' +
            '<div class="row margin-top-36">' +
                '<div class="field-label">Workspace URL</div>' +
                '<div class="input-subdomain">' +
                    '<div>' +
                        '<span class="url-validation"><i class="far fa-check text-success"></i></span>' +
                        '<span class="subdomain">' +
                            '<input type="text" name="subdomain" maxlength="50" placeholder="mycompany">' +
                        '</span>' +
                        '<span class="host-name">' + Cache.app.configs.workspace_host + '</span>' +
                    '</div>' +
                '</div>' +
                '<div class="text-danger text-medium url-taken">This url is already taken</div>' +
            '</div>' +
            '<div class="row margin-top-36">' +
                '<div class="field-label">Workspace Logo</div>' +
                '<div class="text-info text-medium">Recommended size: 128 x 128 (png, jpg or svg)</div>' +
                '<div>' +
                    '<div class="workspace-logo"></div>' +
                '</div>' +
            '</div>' +
            '<hr>' +
            '<div class="margin-top-48 text-align-center">' +
                '<button type="button" class="primary submit" disabled>Create Workspace</button>' +
            '</div>' +
        '</div>';

        this.$el.html(content);

        this.renderLogo();

        // focus after render
        setTimeout(() => {
            this.$el.find('input:first').focus();
        });

        return this;
    }
});